import React,{useEffect, useState} from 'react' 
import arrayShuffle from 'array-shuffle';

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { text } from '@fortawesome/fontawesome-svg-core';


function importAll(r) {
    let images = {};
        r.keys().forEach((item, index) => { images[item.replace('./', '').replace(".jpg","")] = r(item); });
    return images
}

const images18 = importAll(require.context('../../../images/enfants', false, /\.(png|jpe?g|svg|mp4)$/));
const images17 = importAll(require.context('../../../images/commisariat', false, /\.(png|jpe?g|svg|mp4)$/));
const images16 = importAll(require.context('../../../images/pakadjuma 2', false, /\.(png|jpe?g|svg|mp4)$/));
const images15 = importAll(require.context('../../../images/journee_internationale', false, /\.(png|jpe?g|svg|mp4)$/));
const images14 = importAll(require.context('../../../images/gratuit_pakadjuma', false, /\.(png|jpe?g|svg|mp4)$/));
const images13 = importAll(require.context('../../../images/centre', false, /\.(png|jpe?g|svg|mp4)$/));
const images12 = importAll(require.context('../../../images/pakadjuma', false, /\.(png|jpe?g|svg|mp4)$/));
const images11 = importAll(require.context('../../../images/gratuit', false, /\.(png|jpe?g|svg|mp4)$/));
const images10 = importAll(require.context('../../../images/vieillards', false, /\.(png|jpe?g|svg|mp4)$/));
const images9 = importAll(require.context('../../../images/award', false, /\.(png|jpe?g|svg|mp4)$/));
const images8 = importAll(require.context('../../../images/kitambo', false, /\.(png|jpe?g|svg|mp4)$/));
const images7 = importAll(require.context('../../../images/kalembelembe', false, /\.(png|jpe?g|svg|mp4)$/));
const images6 = importAll(require.context('../../../images/clinique_mobile', false, /\.(png|jpe?g|svg|mp4)$/));
const images5 = importAll(require.context('../../../images/kadima', false, /\.(png|jpe?g|svg|mp4)$/));
const images4 = importAll(require.context('../../../images/limete', false, /\.(png|jpe?g|svg|mp4)$/));
const images3 = importAll(require.context('../../../images/2023', false, /\.(png|jpe?g|svg|mp4)$/));
const images2 = importAll(require.context('../../../images/nurse_day', false, /\.(png|jpe?g|svg|mp4)$/));
const images1 = importAll(require.context('../../../images/roster', false, /\.(png|jpe?g|svg)$/));

const images = [
    {
        name:images18,
        text:`
            Les enfants démunis de pakadjuma retrouvent leurs sourires grâce à madame tanyiwa qui a fait un don des habits au travers l'ASBL 
            Infirmières des Voies Publiques (IVP) par l'entremise de sa présidente madame Marie France BOMENGO.
        `
    },{
        name:images17,
        text:`
            C'est sous une bonne température que les Infirmières des Voies Publiques (IVP ) ont effectué une descente sur la rue comme à la coutumier, Munis des bacs des médicaments,pains,jus pour offrir les soins de première nécessité aux enfants de la rue et personnes vulnérables.
            Le commissariat de la police de 7ème rue Limeté a servi du cadre à plus de 35 personnes démunies d'en  profiter les soins gratuits.
            La journée s'est clôturée par une visite d'un ASBL petit vital voulant bien accompagner les IVP dans leurs prochaines  descente.
        `
    },{
        name:images16,
        text:`Soins aux personnes démunies à pakadjuma`
    },{
        name:images15,
        text:`Journée internationale des personnes âgées. Vieillir dans la dignité : l'importance de renforcer les systèmes de santé et d'aide aux personnes âgées dans le monde entier. Les Infirmières des Voies Public (IVP) à l'hospice des vieillards de kabinda en partenariat avec la fondation KADIMA de Kinshasa.`
    },{
        name:images14,
        text:`Soins gratuits à pakadjuma`
    },{
        name:images13,
        text:`soins aux centre des handicapés de kitambo, 
        plus de 68 handicapés ainsi que leurs enfants tous ont reçu le soins chaqu'un selon sa maladie, grâce à l'appui de la fondation kadima`
    },{
        name:images12,
        text:`Soins gratuits aux personnes démunies à pakadjuma`
    },{
        name:images11,
        text:`Les infirmières des voies publiques à limeté, soins gratuit aux enfants de a rue`
    },{
        name:images10,
        text:`
        `
    },{
        name:images9,
        text:`
            La présidente de l'ASBL Infirmièrs des Voies Publiques (I.V.P) en sigle
            Madame Marie-Françoise MAMBIA BOMENGO a reçu  le prix de la médecine du trophée MWASI YA TALO.
            Primée par le jury membre de l’ongd SD Magistral pour son sempiternel travail d’administrer des soins médicaux gratuits aux enfants vulnérables, particulièrement les orphelins, 
            les enfants en situation de rue, les enfants en conflit avec la loi et ceux habitant dans des quartiers défavorisés.
            Ce prestigieux trophée motive mon équipe et moi, à donner encore le meilleur de nous pour le bien-être des plus petits.
            Comme vous le savez si bien. La prise en charge sanitaire des enfants défavorisés nécessite des moyens considérables que les sociétaires de l’asbl ne sauraient supporter eux même.
            C’est pourquoi, notre association est à la recherche des partenaires qui pourraient nous aider soit nous faire un don en matériels médicaux , produits pharmaceutiques ou toute autre forme d’aide financière.
        `
    },{
        name:images8,
        text:`
            Plus de 68 patients handicapés ont bénéficié du traitement lors de la descente effectuer au centre des personnes vivant avec handicap 
            de kitambo précisément à Kinshasa dont 52 adultes,7 enfants et 9 personnes validées comme membres des familles de handicapés tel est 
            le rapport de la présidente de l'ASBL infirmièrs de voies publiques que dirige madame Marie France BOMENGO. 
            Selon elle,ce dernier temps l'observation est positive allant du  12 au 17 juillet càd la plupart des handicapés ont bien 
            suivi leurs séances des traitements, remercie également le président de la fondation kadima pour cette disponibilité et la franche collaboration.
        `
    },{
        name:images7,
        text:`
            Clinique mobile, l'équipe des infirmiers des voies publiques ont effectué une descente au centre des personnes 
            vivant avec handicap de kalembelembe précisément dans la commune de lingwala a total 31 
            personnes handicapées et 4enfants soigné relativement à leurs maladies, Signal Madame Marie 
            France BOMENGO présidente de cette ASBL avec un constat d'une bonne l'évolution des patients hypertendus 
            qui avez reçu le traitement des anti hypertenseurs le mois passé.
        `
    },{
        name:images6,
        text:`
            Toujours dans le programme CLINIQUE MOBILE, 
            les Infirmièrs des Voies Publiques IVP KINSHASA ont administré à plus de 30 vieillards 
            les soins de premièr nécessité à l'hospice de vieillards de kabinda grâce à l'appuis de la fondation kadima
        `
    },{
        name:images5,
        text:`
            C'est depuis près d'un mois que la Fondation Kadima s'associe avec l'association des Infirmiers des Voies Publiques pour rapprocher les malades 
            (Vieillards, Orphelins et handicapes. ) des soignants à travers la clinique mobile. En images, la descente au centre des handicapés. 
            Si vous êtes intéressés, n'hésitez pas à nous contacter
        `
    },{
        name:images4,
        text:`
            Toujours dans l'objectif de secourir les enfants délaissés, 
            L'Equipe des Infirmiers des Voies Publiques (I.V.P) dirigée par sa présidente Marie France BOMENGO on fait une descente à limeté première rue Kinshasa, 
            plus de 30 enfants ont reçu chacun un sachet des médicaments  pour le traitement de la malaria, Gale, infection et bien d'autres maladies transmissibles 
            et pour ceux ayant des plaies on était traité, ensemble recourons Les enfants délaissés
        `
    },{
        name:images3,
        text:`
            Un sourire reviens aux enfants vulnérables en ce jour de l'an 2023 à l'orphelinat de Kinshasa, 
            la grande équipe des infirmiers des voies  Publiques (IVP) que dirige madame Marie France BOMENGO accompagné de 
            madame ABONGO Michel charlotte qui ont donné avec tout cœur les vermifuges aux enfants et quelques médicaments en stock pour leur traitement. 
            Ensemble soutenons les vulnérables
        `
    },{
        name:images2,
        text:`
            C'était à l'occasion de la journée mondiale des infirmiers que l'équipe de l'IVP KINSHASA s'est rendue à kinkole dans la commune de Nsele, 
            pour donner les soins de première nécessité aux enfants vulnérables, plus de 30 enfants ont reçu chacun le produit de vermifuges plus un traitement, 
            et d'autres on était circoncis grâce à l'appui de cette structure, qui vient en aide dans ce lieu.
        `
    },{
        name:images1,
        text:``
    }
]



const roster = images.map(image => {
    return {
        images: arrayShuffle(Object.values(image.name)),
        text: image.text
    }
})


const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


const Gallery = () => {

    return(
        <React.Fragment>
            { roster.map(item => 
                <div>
                <Carousel responsive={responsive} className="my-0 lg:my-12" autoPlay autoPlaySpeed={2000}>
                {item.images.map(item => {
                    const link = item.default.toString().split(".")
                    const extention = link[link.length - 1]
                    console.log(extention)
                    if(extention === "jpg" || extention === "jpeg" || extention === "png"){
                        return(
                            <img src={item.default} className="h-52 lg:h-96 mx-auto p-2 lg:p-12"/>
                        )
                    }

                    return(
                        <video  controls>
                            <source className="relative block w-full bg-white rounded-lg overflow-hidden focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" src={item.default} type="video/mp4"></source>
                            Your browser does not support the video tag.

                        </video>
                    )

                })}
                
                {/* <div>Item 2</div>
                <div>Item 3</div>
                <div>Item 4</div> */}
            </Carousel>
            <div className='w-50 lg:px-64 px-10 text-lg mb-36 lg:mt-0 mt-12'>
                {item.text}
            </div>
            </div>)}

        </React.Fragment>
    )
}

export default Gallery